import { render } from "./component-kod-okved.vue?vue&type=template&id=03287c88"
import script from "./component-kod-okved.vue?vue&type=script&setup=true&lang=js"
export * from "./component-kod-okved.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-kod-okved.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03287c88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03287c88', __exports__)) {
    api.reload('03287c88', __exports__)
  }
  
  module.hot.accept("./component-kod-okved.vue?vue&type=template&id=03287c88", () => {
    api.rerender('03287c88', render)
  })

}


export default __exports__